import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { db } from '../../firebaseConfig';
import { collection, addDoc, query, orderBy, onSnapshot, updateDoc, doc, getDoc } from 'firebase/firestore';
import { Box, Paper, Typography, Button } from '@mui/material';

const ChatRoom = () => {
  const { userId, groupId } = useParams(); 
  const [messages, setMessages] = useState([]);
  const [newMessage, setNewMessage] = useState('');
  const [userName, setUserName] = useState(''); 
  const [groupName, setGroupName] = useState(''); 

  useEffect(() => {
    const getUser = async () => {
      const userDoc = await getDoc(doc(db, 'userDetails', userId));
      if (userDoc && userDoc.data()) {
        setUserName(userDoc.data().name);
      }
    };
    getUser();
  }, [userId]);

  useEffect(() => {
    const getGroup = async () => {
      const groupDoc = await getDoc(doc(db, 'chatGroups', groupId));
      if (groupDoc && groupDoc.data()) {
        setGroupName(groupDoc.data().name);
      }
    };
    getGroup();
  }, [groupId]);

  useEffect(() => {
    const q = query(collection(db, 'chatGroups', groupId, 'messages'), orderBy('timestamp'));
    const unsubscribe = onSnapshot(q, (snapshot) => {
      const messagesList = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setMessages(messagesList);
    });

    return () => unsubscribe(); // Clean up the listener on component unmount
  }, [groupId]);

  // Handle sending a message
  const handleSendMessage = async () => {
    if (newMessage.trim() === '') return;

    // Parse hashtags from the message
    const hashtags = newMessage.match(/#[a-zA-Z0-9_]+/g) || [];

    await addDoc(collection(db, 'chatGroups', groupId, 'messages'), {
      userId,
      message: newMessage,
      timestamp: new Date(),
      reports: [],
      hashtags
    });

    setNewMessage('');
  };

  // Report a message
  const handleReportMessage = async (messageId) => {
    const messageDoc = doc(db, 'chatGroups', groupId, 'messages', messageId);
    const message = messages.find(msg => msg.id === messageId);

    // Update reports
    if (!message.reports.includes(userId)) {
      await updateDoc(messageDoc, {
        reports: [...message.reports, userId]
      });
      alert("Message reported!");
    } else {
      alert("You've already reported this message.");
    }
  };

  // Handle clicking on a hashtag
  const handleHashtagClick = (hashtag) => {
    const filteredMessages = messages.filter(msg => msg.hashtags.includes(hashtag));
    setMessages(filteredMessages); // Filter messages by hashtag
  };

  return (
    <div style={{display:'flex', justifyContent:'space-between', backgroundColor:"#CED0E8"}}>
      
        <Typography variant="h5" sx={{ textAlign: 'center', padding: 2, color: 'black',  width:"13%" }}>
          {groupName}
        </Typography>
    <Box sx={{ display: 'flex', height: '100vh', padding: 2, marginLeft:20 ,  width:"100%"}}>
      <Box sx={{ flex: 1, padding: 2, border: '1px solid black', borderRadius: 2}}>
        {messages.map((msg, index) => (
          <Typography key={index} variant="body1" sx={{ marginBottom: 2 }}>
            <strong>{userName}</strong>: {msg.message}
            <Button sx={{color:"red", fontSize:"10px", fontWeight:600}} onClick={() => handleReportMessage(msg.id)}>Report</Button>
            <div>
              {msg.hashtags && msg.hashtags.length > 0 && (
                msg.hashtags.map(hashtag => (
                  <span
                    key={hashtag}
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() => handleHashtagClick(hashtag)}
                  >
                    {hashtag}
                  </span>
                ))
              )}
            </div>
          </Typography>
        ))}
      </Box>
      <Box sx={{ width: 300, padding: 2, border: '1px solid #ddd', borderRadius: 2, marginLeft: 2}}>
        <input
          type="text"
          value={newMessage}
          onChange={(e) => setNewMessage(e.target.value)}
          placeholder="Type a message..."
          sx={{ width: '100%', padding: 2, marginBottom: 2}}
        />
        <Button onClick={handleSendMessage}>Send</Button>
      </Box>
    </Box>
    </div>
  );
};

export default ChatRoom;